import { ArrowDownBoldCircleOutlineIcon } from './ArrowDownBoldCircleOutlineIcon';

/**
 * author: Austin Andrews
 * id 1DA60E82-C1F0-449C-8157-7014A7C9E749
 * name arrow-down-bold-circle-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-down-bold-circle-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowBottomBoldCircleOutlineIcon = ArrowDownBoldCircleOutlineIcon;
export default ArrowBottomBoldCircleOutlineIcon